import React from 'react'
import PropTypes from 'prop-types'
import { withCookieConsent } from 'LiveBoard/hocs'
import { HEADER_ICONS } from 'common/constants/CampaignHeaderIcons'
import Logo from './Logo'
import { TAB_INDEX_INDICATIONS, TAB_INDEXES } from 'shared/helpers/AccessibilityHelper'
import get from 'lodash/get'

import './style.css.scss'

const LogosArea = (props) => {
  const hasDynamicLogo = props.config.logo.type === 'dynamic' || get(props.config.secondaryLogo, 'type') === 'dynamic'

  return (
    <div>
      {props.config.logo.show &&
        <div className={`logo-container ${(props.withPadding || props.config.logo.with_padding) ? ' padding' : ''}`} >
          { get(props.config.logo, 'image.url') && (!props.config.logo.type || props.config.logo.type === 'manual') && (
            <Logo
              config={props.config.logo}
              onClick={() => props.onCookieConsent()}
              tabIndex={props.config.logo.link ? TAB_INDEXES.LogoFirst : TAB_INDEX_INDICATIONS.skip} />
          )}
          {
            get(props.config.secondaryLogo, 'show') && get(props.config.secondaryLogo, 'image.url') &&
            <span>
              {!hasDynamicLogo && <span
                className={`header-icon ${get(HEADER_ICONS, [props.config.icon, 'icon'], '')}`} />
              }
              {(!props.config.secondaryLogo.type || props.config.secondaryLogo.type === 'manual') &&
                <Logo
                  config={props.config.secondaryLogo}
                  onClick={() => props.onCookieConsent()}
                  tabIndex={props.config.secondaryLogo.link ? TAB_INDEXES.LogoSecond : TAB_INDEX_INDICATIONS.skip} />
              }
            </span>
          }
        </div>
      }
    </div>
  )
}

LogosArea.propTypes = {
  config: PropTypes.object.isRequired,
  onCookieConsent: PropTypes.func.isRequired,
  withPadding: PropTypes.bool
}

export default withCookieConsent(LogosArea)
